import * as React from 'react';

export const XIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="X"
    >
      <path
        d="M2.36797 2.4L8.23281 10.95L2.49218 17.6H3.76406L8.79453 11.7688L12.7945 17.6H17.6L11.4727 8.66797L16.8797 2.4H15.6117L10.9102 7.84688L7.17343 2.4H2.36797ZM3.88672 3.2H6.75234L16.0812 16.8H13.2156L3.88672 3.2Z"
        fill="currentColor"
      />
    </svg>
  );
};
